import React from 'react';
import isPlainObject from 'lodash/isPlainObject';
import { executeFunction, getLowCodeCoreUtil, isArrayNotEmpty } from '@/common/util/util';
export const getExtraDom = (props) => {
    const { extra, _context } = props || {};
    const state = _context?.state;
    let extraDom = getLowCodeCoreUtil('util.makeButtons')?.({
        buttons: extra?.map((item) => {
            let realChildren = item?.children;
            if (typeof item?.children === 'function') {
                realChildren = executeFunction(item.children, {}, state);
            }
            return {
                ...item,
                size: 'small',
                position: getLowCodeCoreUtil('enumMap.ButtonPosition.tileRightButton'),
                children: realChildren,
            };
        }),
        _context,
        state,
        recordDataSource: {},
    });
    if (isArrayNotEmpty(extraDom)) {
        extraDom = <div className={'cn-layout-section-extra'}>{extraDom}</div>;
    }
    return extraDom;
};
export const getSlotDom = (componentSlot) => {
    if (isArrayNotEmpty(componentSlot)) {
        return componentSlot.map((item) => {
            return React.cloneElement(item, {
                existPosition: 'SectionExtra',
            });
        });
    }
    if (componentSlot) {
        return componentSlot;
    }
    return null;
};
export const getExtraProps = (props) => {
    const { normalStyle, _context, handleProps } = props || {};
    const { noPadding, ...rest } = normalStyle || {};
    let extraProps = {};
    if (noPadding) {
        extraProps.style = {
            paddingLeft: 0,
            paddingRight: 0,
        };
    }
    extraProps = {
        ...extraProps,
        ...rest,
    };
    if (typeof handleProps === 'function') {
        const tempProps = executeFunction(handleProps, { ...extraProps }, _context?.state);
        if (isPlainObject(tempProps)) {
            extraProps = tempProps;
        }
    }
    return extraProps;
};
